module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/212-moldova-7cdbcef98bb4d81e5f27f2ddf24dcc8a.svg";